var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientsPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.4438V19.4438C17 18.383 16.5786 17.3656 15.8284 16.6154C15.0783 15.8653 14.0609 15.4438 13 15.4438H5C3.93913 15.4438 2.92172 15.8653 2.17157 16.6154C1.42143 17.3656 1 18.383 1 19.4438V21.4438",
    stroke: "#041967",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.4438C11.2091 11.4438 13 9.65299 13 7.44385C13 5.23471 11.2091 3.44385 9 3.44385C6.79086 3.44385 5 5.23471 5 7.44385C5 9.65299 6.79086 11.4438 9 11.4438Z",
    stroke: "#041967",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 21.4437V19.4437C22.9993 18.5575 22.7044 17.6965 22.1614 16.996C21.6184 16.2956 20.8581 15.7953 20 15.5737",
    stroke: "#041967",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.57373C16.8604 3.79403 17.623 4.29443 18.1676 4.99604C18.7122 5.69765 19.0078 6.56056 19.0078 7.44873C19.0078 8.3369 18.7122 9.19981 18.1676 9.90142C17.623 10.603 16.8604 11.1034 16 11.3237",
    stroke: "#041967",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsPrimary);
export default __webpack_public_path__ + "static/media/patients_primary.e53574582e53c43fcd0cb37777db3dbf.svg";
export { ForwardRef as ReactComponent };